import { css } from '@compiled/react';

import { useSearchParameters } from '@/components/signup/hooks/use-search-parameters';
import { ProductKey } from '@/components/signup/utils/products';

import { ProductTipListItem } from './product-list-item';

const productTipListStyle = css({
	listStyle: 'none',
	margin: 0,
	padding: 0,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'li:first-of-type': {
		marginBlockStart: 0,
	},
});

export const ProductTipList = () => {
	const { products } = useSearchParameters();
	return (
		<ul css={productTipListStyle}>
			{products.map((productKey) => (
				<ProductTipListItem key={productKey} productKey={productKey as ProductKey} />
			))}
		</ul>
	);
};
